import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll } from 'src/services/Receipts';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function Receipts() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    setLoading(true);
    const res = await getAll();
    const rows =
      res.receipts &&
      res.receipts.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          invoiceID: item.invoiceID,
          receiptNo: item.receipt_number,
          invoiceNo: item.invoice_number,
          receiptDate: item.receipt_date ? formatter('dateOnly', item.receipt_date) : '',
          rawReceiptDate: item.receiptDate,
          remaining: formatter('currency', item.remaining),
          paymentAmount: formatter('currency', item.payment_amount),
          grandTotal: formatter('currency', item.grand_total),
          customerName: item.customer,
          dueDate: item.due_date ? formatter('dateOnly', item.due_date) : '',
          rawDueDate: item.due_date,
          rawRemaining: item.remaining,
          rawPaymentAmount: item.payment_amount,
          rawGrandTotal: item.grand_total,
          notes: item.notes,
          bankID: item.bank_id,
          bankName: item.bankName
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'receiptNo', headerName: 'Receipt #', width: '150' },
      { field: 'invoiceNo', headerName: 'Invoice #', width: '200' },
      { field: 'receiptDate', headerName: 'Tanggal Pembayaran', width: '150' },
      { field: 'paymentAmount', headerName: 'Jumlah Pembayaran', width: '150' },
      { field: 'grandTotal', headerName: 'Grand Total', width: '150' },
      { field: 'remaining', headerName: 'Sisa', width: '150' },
      { field: 'customerName', headerName: 'Customer', width: '200' },
      { field: 'dueDate', headerName: 'Jatuh Tempo', width: '150' }
    ];

    setDataColumns(columns);
    setLoading(false);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/receipt-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Receipt </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/receipt-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel rows={dataRows} columns={dataColumns} excelName="Daftar Produk" config={{ width: '20' }} />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            loading={loading}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Receipts;
